import { useState, useEffect } from 'react';

/**
 * Returns true if Item Subgroup custom field is enabled.
 * Defaults to false (disabled) if no setting has been saved.
 */
export const isItemSubgroupEnabled = () => {
    try {
        const cached = localStorage.getItem('enable_item_subgroup');
        return cached === 'true';
    } catch (e) {
        return false;
    }
};

/**
 * Hook providing reactive access to the Item Subgroup enabled state.
 * Listens for local updates and cross-tab storage changes.
 */
export const useItemSubgroupSetting = () => {
    const [enableItemSubgroup, setEnableItemSubgroup] = useState(isItemSubgroupEnabled());

    useEffect(() => {
        const handleStorageChange = () => {
            setEnableItemSubgroup(isItemSubgroupEnabled());
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('item_subgroup_setting_changed', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('item_subgroup_setting_changed', handleStorageChange);
        };
    }, []);

    const updateItemSubgroupSetting = (enabled) => {
        const strVal = enabled ? 'true' : 'false';
        localStorage.setItem('enable_item_subgroup', strVal);
        setEnableItemSubgroup(enabled);
        window.dispatchEvent(new Event('item_subgroup_setting_changed'));
        window.dispatchEvent(new Event('storage'));
    };

    return { enableItemSubgroup, updateItemSubgroupSetting };
};

export default useItemSubgroupSetting;
